import React from 'react';
import { motion } from 'framer-motion';

const Research = () => {
  return (
    <section id="research" className="py-20 px-6 bg-gray-900 text-gray-100">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="max-w-4xl mx-auto text-center"
      >
        <h2 className="text-3xl font-bold mb-4">Research & Future Vision</h2>
        <p>
          Munorva is actively researching next-generation AI-driven
          communication systems, intelligent infrastructure platforms, and
          scalable embedded technologies designed to power future communities.
          Our work is visionary, ambitious, and aimed at redefining how
          technologies serve people.
        </p>
      </motion.div>
    </section>
  );
};

export default Research;
